import _ from 'lodash';
import { createSelector } from 'reselect';

export const getCenter = state => _.get(state, "center.center", {});

export const getCenterId = createSelector([getCenter], center => {
    return _.get(center, "id");
});